/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { GPUConfig } from './gpuconfig';
// May contain unused imports in some cases
// @ts-ignore
import type { KubernetesTaint } from './kubernetes-taint';

/**
 * Message to describe edge provisioning details.
 * @export
 * @interface Edge
 */
export interface Edge {
    /**
     * Boot disk size in GiB.
     * @type {number}
     * @memberof Edge
     */
    'bootDiskGib'?: number;
    /**
     * Client request ID is an identifier you provide to ensure the idempotency of the request.
     * @type {string}
     * @memberof Edge
     */
    'clientRequestId'?: string;
    /**
     * Cloud provider for edge node.
     * @type {string}
     * @memberof Edge
     */
    'cloud'?: string;
    /**
     * A reference to an edge configuration to be used for creating an edge; if not provided then a default one will be used.
     * @type {string}
     * @memberof Edge
     */
    'configurationId'?: string;
    /**
     * The creation timestamp.
     * @type {string}
     * @memberof Edge
     */
    'createTime'?: string;
    /**
     * Delete protection prevents the edge from being deleted when enabled.
     * @type {boolean}
     * @memberof Edge
     */
    'deleteProtection'?: boolean;
    /**
     * The delete timestamp.
     * @type {string}
     * @memberof Edge
     */
    'deleteTime'?: string;
    /**
     * EdgeLocationID for edge node.
     * @type {string}
     * @memberof Edge
     */
    'edgeLocationId'?: string;
    /**
     * GPU configuration that will be attached to edge node.  Note, only certain providers/instance types support attaching GPU\'s to instance.
     * @type {GPUConfig}
     * @memberof Edge
     */
    'gpuConfig'?: GPUConfig;
    /**
     * The ID of the edge.
     * @type {string}
     * @memberof Edge
     */
    'id'?: string;
    /**
     * ImageID for edge node.
     * @type {string}
     * @memberof Edge
     */
    'imageId'?: string;
    /**
     * Instance labels that are added to the edge node. These are called tags on AWS, labels on GCP.
     * @type {{ [key: string]: string; }}
     * @memberof Edge
     */
    'instanceLabels'?: { [key: string]: string; };
    /**
     * Instance type of the edge node.
     * @type {string}
     * @memberof Edge
     */
    'instanceType': string;
    /**
     * Kubernetes labels to be added to the node.  It overrides the labels from the edge configuration in case of a duplicate key.
     * @type {{ [key: string]: string; }}
     * @memberof Edge
     */
    'kubernetesLabels'?: { [key: string]: string; };
    /**
     * Kubernetes node name.
     * @type {string}
     * @memberof Edge
     */
    'kubernetesName'?: string;
    /**
     * Kubernetes taints to be added to the node.  It overrides the taints from the edge configuration in case of a duplicate key.
     * @type {Array<KubernetesTaint>}
     * @memberof Edge
     */
    'kubernetesTaints'?: Array<KubernetesTaint>;
    /**
     * Name of the edge node.
     * @type {string}
     * @memberof Edge
     */
    'name': string;
    /**
     * Node architecture (e.g., \"X86_64, ARM64\").
     * @type {string}
     * @memberof Edge
     */
    'nodeArchitecture': EdgeNodeArchitectureEnum;
    /**
     * Status of the edge with details from agent/client side.
     * @type {string}
     * @memberof Edge
     */
    'phase'?: EdgePhaseEnum;
    /**
     * ProviderID for edge node. This will reflect providerID field in Kubernetes node spec.
     * @type {string}
     * @memberof Edge
     */
    'providerId'?: string;
    /**
     * Region specific for a created edge.
     * @type {string}
     * @memberof Edge
     */
    'region'?: string;
    /**
     * Scheduling type of edge node. Defaults to on-demand.
     * @type {string}
     * @memberof Edge
     */
    'schedulingType': EdgeSchedulingTypeEnum;
    /**
     * The last update timestamp.
     * @type {string}
     * @memberof Edge
     */
    'updateTime'?: string;
    /**
     * The version of the edge configuration used for creating an edge.
     * @type {number}
     * @memberof Edge
     */
    'version'?: number;
    /**
     * The zone for edge node. Zone must be part of edge location.
     * @type {string}
     * @memberof Edge
     */
    'zone': string;
    /**
     * ZoneID specific for a created edge.
     * @type {string}
     * @memberof Edge
     */
    'zoneId'?: string;
}

export const EdgeNodeArchitectureEnum = {
    ARCHITECTURE_UNSPECIFIED: 'ARCHITECTURE_UNSPECIFIED',
    X86_64: 'X86_64',
    ARM64: 'ARM64'
} as const;

export type EdgeNodeArchitectureEnum = typeof EdgeNodeArchitectureEnum[keyof typeof EdgeNodeArchitectureEnum];
export const EdgePhaseEnum = {
    PHASE_UNSPECIFIED: 'PHASE_UNSPECIFIED',
    CREATING: 'CREATING',
    READY: 'READY',
    FAILED: 'FAILED',
    UNKNOWN: 'UNKNOWN',
    DELETING: 'DELETING',
    DELETED: 'DELETED'
} as const;

export type EdgePhaseEnum = typeof EdgePhaseEnum[keyof typeof EdgePhaseEnum];
export const EdgeSchedulingTypeEnum = {
    SCHEDULING_TYPE_UNSPECIFIED: 'SCHEDULING_TYPE_UNSPECIFIED',
    ON_DEMAND: 'ON_DEMAND',
    SPOT: 'SPOT'
} as const;

export type EdgeSchedulingTypeEnum = typeof EdgeSchedulingTypeEnum[keyof typeof EdgeSchedulingTypeEnum];


